import { Guardian } from '@xaamin/guardian';

Guardian.define('compra.listar', (user) => {
  return user.can('compra.listar');
});

Guardian.define('compra.comprar', (user) => {
  return user.can('compra.comprar');
});

Guardian.define('compra.pago.transferencia', (user) => {
  return user.can('compra.pago.transferencia');
});
